import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

import { TvoedSalaryService, TvoedSubTableData } from '@metallgehalt/tvoed-salary-calculator';

@Component({
  selector: 'tvoed-table',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './tvoed-table.component.html',
  styleUrl: './tvoed-table.component.scss'
})
export class TvoedTableComponent implements OnInit {
  salaryService = inject(TvoedSalaryService);
  activatedRoute = inject(ActivatedRoute);
  titleService = inject(Title);
  metaService = inject(Meta);

  tvoedData!: TvoedSubTableData;
  year!: number;
  subTable!: string;
  tableData: { EG: string; [key: string]: string | number }[] = [];
  displayedColumns: string[] = [];

  ngOnInit() {
    this.year = this.activatedRoute.snapshot.params['tarifänderung'];
    this.subTable = this.activatedRoute.snapshot.params['bereich'];

    this.metaService.updateTag({
      name: 'description',
      content: `TVöD Entgelttabelle ${this.subTable} ${this.year} – Alle Entgeltgruppen und Stufen`
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: `TVöD, Entgelttabelle ${this.year}, ${this.subTable}, Gehaltstabelle, Entgeltgruppe, Stufe, öffentlicher Dienst`
    });

    this.salaryService.getSubTable(this.year, this.subTable).subscribe(tvoedData => {
      this.tvoedData = tvoedData;
      this.titleService.setTitle(`${this.tvoedData.name} ${this.year}`);

      this.generateTableData(this.tvoedData.data);
    });
  }

  generateTableData(jsonData: Record<string, Record<string, number>>): void {
    this.tableData = Object.keys(jsonData).map(key => ({
      EG: key,
      ...jsonData[key]
    }));

    const unionColumns: string[] = [];
    Object.keys(jsonData).forEach(key => {
      const row = jsonData[key];
      Object.keys(row).forEach(colKey => {
        if (unionColumns.indexOf(colKey) === -1) {
          unionColumns.push(colKey);
        }
      });
    });

    // Sort columns: Stufe 1, Stufe 2, ..., Stufe 6
    unionColumns.sort((a, b) => {
      const numA = parseInt(a.replace(/\D/g, ''), 10);
      const numB = parseInt(b.replace(/\D/g, ''), 10);
      return numA - numB;
    });

    this.displayedColumns = ['EG', ...unionColumns];
  }

  isNumber(val: string | number): boolean {
    return typeof val === 'number';
  }
}
